<template>
    <div class="col-xl-12 float-left background-fff mb-3 roi-widget padding15">
        <h6 class="proxima-nova-bold mb-3">Google Ads</h6>
        <table class="table">
            <thead>
            <tr>
                <th>#</th>
                <th>Domain</th>
                <th>Ads Package</th>
                <th>Status</th>
                <th>Campaigns</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(order, idx) in orders">
                <td>
                    <a :href="'/orders/' + order.number" target="_blank">{{ order.number }}</a>
                </td>
                <td>
                    <a :href="'/googleads/domain/' + order.domain.id" target="_blank">{{ order.domain.name | decodeURI }}</a>
                </td>
                <td>
                    {{ order.ads_package }} {{ order.currency }}
                </td>
                <td>
                    <span v-if="order.overdue_invoices && order.overdue_invoices.length > 0" style="color: red; font-weight: bold">UNPAID</span>
                </td>
                <td>
                    <div v-for="(account, idx1) in order.domain.google_ads_accounts">
                        {{getCampaignsCountByStatus(JSON.parse(account.campaigns), STATUS_PAUSED)}} paused,
                        {{getCampaignsCountByStatus(JSON.parse(account.campaigns), STATUS_ENABLED)}} enabled
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>


import moment from "moment";
import punycode from "punycode";


export default {
    props: ['orders'],
    data: function () {
        return {
            STATUS_UNSPECIFIED:0,
            STATUS_UNKNOWN:1,
            STATUS_ENABLED:2,
            STATUS_PAUSED:3,
            STATUS_REMOVED:4,
        }
    },
    mounted() {
    },
    watch: {

    },
    computed: {

    },
    methods: {
        getCampaignsCountByStatus(campaigns, status){
            let count = 0;
            if(Array.isArray(campaigns)){
                campaigns.forEach(function(campaign, i) {
                    if(campaign.status == status){
                        count += 1;
                    }
                });
            }
            return count;
        }
    },
    filters: {
        decodeURI(URI){
            return punycode.toUnicode(URI);
        },
    }
}
</script>

<style scoped>

</style>
